module.exports = __webpack_public_path__ + "img/pin-polomarket.2a3b1493.svg";